const containerClasses = 'flex flex-col items-start';

const footerClasses = 'mt-auto flex w-full items-center justify-between justify-self-end';

const imageClasses = 'relative';

const minutesReadClasses = 'pl-3 text-right font-normal';

const summaryWrapperClasses = 'grow overflow-hidden';
const summaryClasses = '';

const titleClasses = '';

const cardCommonTheme = {
  containerClasses,
  footerClasses,
  imageClasses,
  minutesReadClasses,
  summaryWrapperClasses,
  summaryClasses,
  titleClasses,
};

export default cardCommonTheme;
